import Component from '@glimmer/component';
import Modal from 'tio-ui/components/modal';
import PhoneVerificationFlow from 'tio-employee/components/app/phone-verification/flow';
import { dropTask } from 'ember-concurrency';
import { service } from '@ember/service';
import { reloadRecord } from 'tio-data/requests/save-record';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type { Store as StoreService } from '@warp-drive/core';

export interface BetaHomeVerifyPhoneModalSignature {
  Args: {
    isOpen: boolean;
    /** Called once the flow is finished with, however it ended. */
    onClose: () => void;
    employee?: EmployeeModel;
  };
}

/**
 * The attention row's flow, held apart from the row so both hosts of the beta home
 * mount the same thing.
 */
export default class BetaHomeVerifyPhoneModal extends Component<BetaHomeVerifyPhoneModalSignature> {
  @service declare store: StoreService;

  /**
   * Re-reads just the phone numbers rather than the whole session: `sessionContext.load`
   * logs the member out on any failure, and a refresh must not end a valid session.
   */
  close = dropTask(async () => {
    this.args.onClose();

    const employee = this.args.employee;
    if (!employee) {
      return;
    }

    await reloadRecord(this.store, employee, { include: 'phone-numbers' });
  });

  <template>
    {{#if @isOpen}}
      <Modal
        @isOpen={{true}}
        @onClose={{this.close.perform}}
        @size="md"
        data-test-beta-home-verify-phone
      >
        <:body>
          {{! Attribution only. The surface list is server-validated and holds no
              dashboard member, so this rides the overlay it shares a flag with. }}
          <PhoneVerificationFlow
            @surface="postLoginOverlay"
            @onVerified={{this.close.perform}}
            @onDeferred={{this.close.perform}}
          />
        </:body>
      </Modal>
    {{/if}}
  </template>
}
